import { isRFQDraft, statusNameFormatter } from "utils/helpers";
import { Icon } from "assets/Icon";
import { getSlug } from "helpers/linkHelper";
import { RFX_STATUS } from "utils/constants";
import { Button } from "newui/components/Button";
import { navigate } from "@reach/router";

interface RFQButtonActionsProject {
	id: number;
	name?: string;
}

interface RFQButtonActionsRfq {
	id?: number | null;
	status?: string;
	supplierListId?: number | null;
}

export interface RFQButtonActionsProps {
	project: RFQButtonActionsProject;
	rfq?: RFQButtonActionsRfq;
	/**
	 * Opens the Create RFx drawer for this row's supplier list. Creation itself
	 * happens inside the drawer, so template selection can't be skipped.
	 */
	onCreateRfx: (supplierListId: number | null) => void;
}

export const RFQButtonActions = ({
	project,
	rfq,
	onCreateRfx,
}: RFQButtonActionsProps) => {
	const rfqId = rfq?.id || null;
	const isHaveRFQ = rfqId !== null;
	const statusName = statusNameFormatter(rfq?.status);
	const isDraft = isRFQDraft(statusName);
	const isPastDeadline = statusName === RFX_STATUS.EVALUATION;

	const slug = getSlug(project?.name);

	const renderButtonText = () => {
		if (!isHaveRFQ) {
			return (
				<>
					{" "}
					<Icon
						icon="plus"
						className="mr-1.5 [&>svg]:h-3 [&>svg]:w-3"
					/>
					Create RFx
				</>
			);
		}
		if (!isPastDeadline && !isDraft) {
			return "View RFx";
		}
		if (isPastDeadline) {
			return "View responses";
		}
		if (isDraft) {
			return "View Draft";
		}
		return null;
	};

	const handleClick = () => {
		if (!isHaveRFQ) {
			onCreateRfx(rfq?.supplierListId ?? null);
			return;
		}
		if (isDraft) {
			navigate(`../../rfx/${rfqId}/edit-rfx`);
			window.scrollTo(0, 0);
			return;
		}
		navigate(`../../rfx/${rfqId}/${slug}/all`);
		window.scrollTo(0, 0);
	};

	return (
		<Button
			btntype={isHaveRFQ ? "secondary" : undefined}
			onClick={handleClick}
			className="mx-auto"
			data-testid="create-rfq"
		>
			{renderButtonText()}
		</Button>
	);
};
